import styled from "styled-components";

export const StyledDiv = styled.div`
    
    color: var(--Primary-text);
    width: 100%;
    height: 100vh;
    display: flex; 
    flex-direction: column; 
    gap: 10;
    background-image: var(--Background-image);
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
    
`;

export const StyledDivDesktop = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    background-color: var(--Primary-background);
    width: 100%;
    height: 100vh;
    color: var(--Primary-text);
    
    
`;

export const PageWrapperDesktop = styled.div`
    height: 100%;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 0 50px;
`

export const PageWrapper = styled.div`
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background-color: var(--Primary-linear);
`



export const FormsContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 80%;
    max-width: 420px;
    border-radius: 20px;
    background-color: var(--Transluced-background);
    padding: 40px 20px;
    gap: 10px;

    @media screen and (min-width: 1025px){
        min-width: 420px;
    }

    div{    
        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
    }
    div:nth-child(3){
        padding-top: 0px;
    }

    button{
        width: 100%;
        max-width: 400px;
        
    }
    p{
        text-align: center;
        opacity: 0.8;
        font-size: 14px;
    }

    span{
        color: var(--Primary-color);
        opacity: 1;
        cursor: pointer;
        font-size: 14px;
    }
`

export const Forms = styled.div`
    flex-direction: column;
    display: flex;
    width: 100%;
    gap: 20px;
    
    max-width: 400px;

    div{
        display: flex;
        flex-direction: column;
        
        gap: 10px;
    }
`

export const ForgotPassword = styled.div`
    font-size: smaller;
    text-align: right;
    opacity: 0.6;
    cursor: pointer;
    margin-top: -10px;
    

    &:hover{
        opacity: 0.8;
    }
`;

export const RecaptchaContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center !important;
    flex-direction: column;
    gap: 10px;
    width: 100%;
    max-width: 400px;
`
